
(function() {
'use strict';

/* ── Custom cursor ── */
var isMouse = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
if (isMouse) {
  var cur = document.getElementById('wby-cursor');
  var ring = document.getElementById('wby-ring');
  var mx=0,my=0,rx=0,ry=0;
  document.addEventListener('mousemove',function(e){
    mx=e.clientX; my=e.clientY;
    cur.style.transform='translate('+(mx-5)+'px,'+(my-5)+'px)';
  });
  (function loop(){
    rx+=(mx-rx-17)*0.1; ry+=(my-ry-17)*0.1;
    ring.style.transform='translate('+rx+'px,'+ry+'px)';
    requestAnimationFrame(loop);
  })();
}

/* ── Particles ── */
var cvs = document.getElementById('wby-particles');
if (cvs) {
  var ctx = cvs.getContext('2d');
  var SYMS = ['✦','◆','▲','●','◇'];
  var pts = [], W, H;
  function resizeCvs(){
    W = cvs.width  = cvs.offsetWidth;
    H = cvs.height = cvs.offsetHeight;
  }
  window.addEventListener('resize', resizeCvs, {passive:true});
  resizeCvs();
  function mkPt(){
    return {
      x:Math.random()*W, y:H+10,
      sz:6+Math.random()*12,
      sp:0.22+Math.random()*0.4,
      dr:(Math.random()-0.5)*0.3,
      op:0.03+Math.random()*0.06,
      sym:SYMS[Math.floor(Math.random()*SYMS.length)],
      rot:Math.random()*Math.PI*2,
      spin:(Math.random()-0.5)*0.008
    };
  }
  for(var i=0;i<24;i++){var p=mkPt();p.y=Math.random()*H;pts.push(p);}
  function drawPts(){
    ctx.clearRect(0,0,W,H);
    for(var j=0;j<pts.length;j++){
      var q=pts[j];
      q.y-=q.sp; q.x+=q.dr; q.rot+=q.spin;
      if(q.y<-10) pts[j]=mkPt();
      ctx.save();
      ctx.globalAlpha=q.op;
      ctx.fillStyle='#fbb813';
      ctx.font=q.sz+'px sans-serif';
      ctx.translate(q.x,q.y);
      ctx.rotate(q.rot);
      ctx.fillText(q.sym,0,0);
      ctx.restore();
    }
    requestAnimationFrame(drawPts);
  }
  drawPts();
}

/* ── Typewriter ── */
var tw = document.getElementById('wby-tw');
if(tw){
  var words=['Convert','Captivate','Perform','Scale'];
  var wi=0,ci=0,del=false;
  function tick(){
    var w=words[wi];
    if(!del){ tw.textContent=w.slice(0,++ci); if(ci===w.length){setTimeout(function(){del=true;tick();},2200);return;} }
    else    { tw.textContent=w.slice(0,--ci); if(ci===0){del=false;wi=(wi+1)%words.length;} }
    setTimeout(tick,del?55:110);
  }
  setTimeout(tick,2000);
}

/* ── Scroll reveal + counters ── */
var revEls = document.querySelectorAll('.reveal');
var ro = new IntersectionObserver(function(entries){
  entries.forEach(function(e){
    if(e.isIntersecting){
      e.target.classList.add('in');
      e.target.querySelectorAll('.counter').forEach(function(c){
        if(!c.dataset.done){ c.dataset.done='1'; countUp(c,+c.dataset.target); }
      });
    }
  });
},{threshold:0.1});
revEls.forEach(function(el){ ro.observe(el); });

function countUp(el,target){
  var t0=null, dur=1600;
  function step(ts){
    if(!t0)t0=ts;
    var p=Math.min((ts-t0)/dur,1);
    var e=1-Math.pow(1-p,3);
    el.textContent=Math.floor(e*target);
    if(p<1) requestAnimationFrame(step);
    else el.textContent=target;
  }
  requestAnimationFrame(step);
}

})();